import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=fbf7a24c&scoped=true"
import script from "./thirdLogin.vue?vue&type=script&lang=js"
export * from "./thirdLogin.vue?vue&type=script&lang=js"
import style0 from "./thirdLogin.vue?vue&type=style&index=0&id=fbf7a24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7a24c",
  null
  
)

export default component.exports